export const UTM_QUERY_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export type RouteQuery = Record<string, string | (string | null)[] | null | undefined>;

function queryParamValue(routeQuery: RouteQuery, key: string): string | undefined {
  const raw = routeQuery[key];
  const value = Array.isArray(raw) ? raw[0] : raw;

  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed || undefined;
}

export function buildUpgradeRedirectLink(params: URLSearchParams, routeQuery: RouteQuery): URLSearchParams {
  UTM_QUERY_PARAMS.forEach((param) => {
    const value = queryParamValue(routeQuery, param);

    if (value) {
      params.append(param, value);
    }
  });

  return params;
}
